export default ($resource) => {
    const base = `${SEED_CORE.ENV.API_URL}form/form`;
    const url = `${base}/:id`;

    return $resource(url, null, {
        search: {
            method: 'POST',
            url: `${base}/search`,
            isArray: true
        },
        getForms: {
            method: 'POST',
            url: `${url}/forms`,
            isArray: true
        },
        update: {
            method: 'PUT',
            url
        },
        assignQuestions: {
            method: 'POST',
            url: `${url}/assign-questions`
        },
        updateQuestionSequence: {
            method: 'POST',
            url: `${url}/update-question-sequence`
        },
        deleteFormQuestion: {
            method: 'DELETE',
            url: `${url}/delete-form-question`
        },
        updateQuestion: {
            method: 'PUT',
            url: `${base}/update-question/:id`
        },
        updateQuestionCategorySequence: {
            method: 'POST',
            url: `${url}/update-question-category-sequence`
        },
        cloneForm: {
            method: 'POST',
            url: `${url}/clone`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/Form/index.js